module.exports = __webpack_public_path__ + "img/avatar-29.8e3783a6.png";